import {
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  Input,
  Label,
  ModalBody,
  Row,
} from "reactstrap";
import { useMutation, useQueryClient, useQuery } from "@tanstack/react-query";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { Btn } from "../../../../../AbstractElements";
import { useAppSelector } from "../../../../../ReduxToolkit/Hooks";

//Services
import {
  DEPARTMENT_QUERY_KEY,
  VIEW_DEPARTMENT_QUERY_KEY,
  departmentService,
} from "../../../../../Services/departmentService";

interface UpdateFormProps {
  toggle?: () => void;
  department_id: number;
}

const UpdateDepartmentForm: React.FC<UpdateFormProps> = ({
  toggle,
  department_id,
}) => {
  const queryClient = useQueryClient();
  const user = useAppSelector((state) => state.auth.user);

  const [formData, setFormData] = useState({
    id: department_id,
    company_code: "",
    name: "",
    division_id: 0,
  });

  const { data: DepartmentData, isLoading: isFetching } = useQuery({
    queryKey: [VIEW_DEPARTMENT_QUERY_KEY, department_id],
    queryFn: () => departmentService.getAllViewDepartmentById(department_id),
  });

  useEffect(() => {
    if (DepartmentData) {
      setFormData({
        id: DepartmentData.id || department_id,
        company_code: DepartmentData.company_code || "",
        name: DepartmentData.department_name || "",
        division_id: DepartmentData.division_id || "",
      });
    }
  }, [DepartmentData]);

  const updateDepartmentMutation = useMutation({
    mutationFn: (data: typeof formData) =>
      departmentService.updateDepartment(department_id, data),
    onSuccess: (result) => {
      queryClient.invalidateQueries({ queryKey: VIEW_DEPARTMENT_QUERY_KEY });
      toast.success(result.message);
      if (toggle) toggle();
    },
    onError: (error: any) => {
      const responseData = error.response?.data;
      if (responseData?.message) {
        toast.error(responseData.message);
      } else {
        toast.error("Failed to update department.");
      }
    },
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    updateDepartmentMutation.mutate(formData);
  };

  return (
    <ModalBody>
      <Form className="needs-validation" onSubmit={handleSubmit}>
        <Row className="g-3">
          <Col md="12">
            <Label>
              Name<b className="text-danger">*</b>
            </Label>
            <Input
              id="name"
              name="name"
              type="text"
              placeholder="Loading..."
              maxLength={150}
              minLength={3}
              required
              value={formData.name}
              onChange={handleInputChange}
              disabled={isFetching}
            />
          </Col>

          <Col md="12">
            <Btn
              color="primary"
              className="w-100"
              type="submit"
              disabled={updateDepartmentMutation.isPending || isFetching}
            >
              {updateDepartmentMutation.isPending
                ? "Updating Department..."
                : "Update"}
            </Btn>
          </Col>
        </Row>
      </Form>
    </ModalBody>
  );
};

export default UpdateDepartmentForm;
